import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import Axios from "../Axios";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import moment from "moment";
const BlogManagement = () => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState();
  const [publishDate, setPublishDate] = useState(moment().format("YYYY-MM-DD"));
  const [description, setDescription] = useState();
  const [allBlogs, setAllBlog] = useState();
  const [userId, setUserId] = useState();
  const [opendel, setOpenDel] = useState(false);
  const [type, setType] = useState();
  const [status, setStatus] = useState(true);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const [img, setImg] = useState("");

  useEffect(() => {
    fetchAllBlog(0, "");
  }, []);

  const fetchAllBlog = (page, search) => {
    let data = {
      page: page,
      searchChar: search,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-blog", data, {
      headers: { Authorization: `Bearer ${localStorage?.getItem("token")}` },
    })
      .then((resp) => {
        setAllBlog(resp?.data?.data);
        setCount(resp?.data?.totalBlogs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    download: false,
    selectableRows: false,
    filter: false,
    viewColumns: false,
    serverSide: true,
    count: count,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllBlog(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllBlog(page, searchText);
      setSearch(searchText);
    },
  };
  const removeHtmlTags = (str) => {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return doc.body.textContent || "";
  };
  const columns = [
    {
      name: "Action",
      label: "Image",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <img
                src={allBlogs[dataIndex]?.image}
                alt=""
                style={{ width: "60px" }}
              />
            </>
          );
        },
      },
    },
    {
      name: "title",
      label: "Blogs Title",
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: "content",
      label: "Description",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const cleanAnswer = removeHtmlTags(
            allBlogs[dataIndex]?.content || ""
          ); // Remove HTML tags
          return (
            <div className="parent-container">
              <p className="clamp-3-lines">{cleanAnswer}</p>
            </div>
          );
        },
        setCellProps: () => ({
          style: { width: "150px", whiteSpace: "normal" }, // Set width directly here
        }),
      },
    },
    {
      name: "publishedAt",
      label: "Publish Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(allBlogs[dataIndex].publishedAt).format("DD-MM-YYYY")}
            </div>
          );
        },
      },
    },
    {
      name: "display",
      label: "Display Status",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <p
              className={
                allBlogs[dataIndex]?.display
                  ? "active-user fs-14 fw-600 m-1"
                  : "inactive fs-14 fw-600 m-1"
              }
            >
              {allBlogs[dataIndex]?.display ? "Published" : "Unpublished"}
            </p>
          );
        },
      },
    },

    {
      name: "Action",
      label: "Action",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="View">
                <IconButton
                  aria-label="View Blogs"
                  onClick={() => handleOpen(allBlogs[dataIndex], "view")}
                >
                  <RemoveRedEyeOutlinedIcon className="fs-20 " />
                </IconButton>
              </Tooltip>

              <>
                <Tooltip title="Edit">
                  <IconButton
                    aria-label="Edit Blogs"
                    onClick={() => handleOpen(allBlogs[dataIndex], "edit")}
                  >
                    <EditOutlinedIcon className="fs-20 edit-icon" />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={allBlogs[dataIndex]?.display ? "Unpublish" : "Publish"}
                >
                  <IconButton
                    aria-label="sss"
                    onClick={() =>
                      handleOpen(
                        allBlogs[dataIndex]._id,
                        "block",
                        allBlogs[dataIndex]?.display
                      )
                    }
                  >
                    <BlockOutlinedIcon className="fs-20 delete-icon" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton
                    aria-label="Delete Blogs"
                    onClick={() =>
                      handleOpen(allBlogs[dataIndex]._id, "delete")
                    }
                  >
                    <DeleteOutlineOutlinedIcon className="fs-20 delete-icon" />
                  </IconButton>
                </Tooltip>
              </>
            </>
          );
        },
      },
    },
  ];
  // Function for dialog open close
  const handleOpen = (userid, type, status) => {
    if (type === "delete") {
      setUserId(userid);
      setOpenDel(true);
    } else if (type === "block") {
      setUserId(userid);
      setOpenDel(true);
      setStatus(status);
      setType("block");
    } else if (type === "edit") {
      setName(userid?.title);
      setDescription(userid?.content);
      setUserId(userid._id);
      setType("edit");
      setOpen(true);
      setPublishDate(moment(userid.publishedAt).format("YYYY-MM-DD"));
    } else if (type === "view") {
      setName(userid?.title);
      setPublishDate(moment(userid.publishedAt).format("YYYY-MM-DD"));
      setDescription(userid?.content);
      setUserId(userid._id);
      setImg(userid?.image);
      setType("view");
      setOpen(true);
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setOpenDel(false);
    setType("");
    setName("");
    setDescription("");
    setUserId("");
    setStatus(true);
    setPublishDate(moment().format("YYYY-MM-DD"));
  };

  // Function to set the data in the appropriate state
  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "name") {
      setName(value);
    } else if (name === "description") {
      setDescription(value);
    }
  };
  // Function top create a new user
  const handleSubmit = () => {
    if (name === "" || name === null || name === undefined) {
      toast.error("Title is required");
      return;
    }
    if (
      description === "" ||
      description === null ||
      description === undefined
    ) {
      toast.error("Description  is required");
      return;
    }
    const formData = new FormData();
    let api;
    if (type === "edit") {
      api = "update-blog";
      formData.append("title", name);
      formData.append("publishedAt", publishDate);
      formData.append("content", description);
      formData.append("image", img ? img : "");
      formData.append("id", userId);
    } else {
      formData.append("title", name);
      formData.append("publishedAt", publishDate);
      formData.append("content", description);
      formData.append("image", img ? img : "");
      api = "create-blog";
    }
    Axios.post(process.env.REACT_APP_BACKEND + api, formData, {
      headers: { Authorization: `Bearer ${localStorage?.getItem("token")}` },
    })
      .then((resp) => {
        fetchAllBlog(0, "");
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  // Function to delete the user
  const handleDelete = () => {
    let api;
    if (type === "block") {
      api = "update-status-blog";
    } else {
      api = "delete-blog";
    }
    Axios.post(
      process.env.REACT_APP_BACKEND + api,
      {
        id: userId,
      },
      {
        headers: { Authorization: `Bearer ${localStorage?.getItem("token")}` },
      }
    )
      .then((resp) => {
        fetchAllBlog(0, "");
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //function to set the state for pdf or video
  const handlePDF = (event) => {
    const selectedImage = event.target.files[0];
    setImg(selectedImage);
  };

  return (
    <div className="p-4">
      <div
        className="mb-5"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2 className="primary_title text-start about_heading m-2 mb-3">
          Blog Management
        </h2>

        <Button variant="contained" className="btn ms-4" onClick={handleOpen}>
          Add
        </Button>
      </div>
      <MUIDataTable
        title={"Blogs Room List"}
        data={allBlogs}
        columns={columns}
        options={options}
      />

      {/* ------------------------------Create Blogs Section ---------------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
        maxWidth="xl"
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>
            {" "}
            {type === "edit"
              ? "Edit Blogs Details"
              : type === "view"
              ? "View Blogs"
              : "Create Blogs"}
          </h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          {type === "view" ? (
            <>
              <div className="viewDetials">
                <h3 className="view-style fs-20 fw-600 mb-4">{name}</h3>
                <p className="fs-12 fw-500 ms-2 mb-2">Publish Date</p>
                <div className="capsule published">{publishDate}</div>
                <div>
                  <img src={img} alt="" style={{ width: "25%" }} />
                </div>
                <div
                  className="view-style fs-14 mt-4"
                  style={{ textAlign: "justify" }}
                  dangerouslySetInnerHTML={{
                    __html: description.replace(/<\/?p>/g, ""), // Removes all <p> and </p> tags
                  }}
                ></div>
              </div>
            </>
          ) : (
            <>
              <p className="fs-14 fw-500 my-3">Image</p>
              <div className="col-md-6 ">
                <input
                  type="file"
                  accept=".png, .jpg"
                  onChange={handlePDF}
                  className="w60 gray-border mb-4"
                />
              </div>
              <p className="fs-14 fw-500 mb-3">Title</p>
              <TextField
                variant="outlined"
                required
                fullWidth
                className="my-2"
                placeholder="Enter Blog title"
                name="name"
                onChange={handleChange}
                value={name}
                InputProps={{
                  readOnly: type === "view", // Makes the field read-only if `type` is "view"
                }}
              />
              <p className="fs-14 fw-500 mb-3">Publish Date</p>
              <TextField
                variant="outlined"
                required
                fullWidth
                className="my-2"
                type="date"
                placeholder="Enter Blog title"
                name="name"
                onChange={(event) => setPublishDate(event.target.value)}
                value={publishDate}
                InputProps={{
                  readOnly: type === "view", // Makes the field read-only if `type` is "view"
                }}
              />

              <p className="fs-14 fw-500 mb-3">Description</p>
              <ReactQuill
                theme="snow"
                value={description}
                className="my-2"
                onChange={setDescription}
                style={{ height: "300px" }}
                readOnly={type === "view"}
                modules={{
                  toolbar: [
                    [{ header: "1" }, { header: "2" }, { font: [] }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ align: [] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ color: [] }, { background: [] }],
                    [{ script: "sub" }, { script: "super" }],
                    ["link", "image"],
                    ["blockquote", "code-block"],
                    ["clean"],
                  ],
                }}
              />
            </>
          )}
        </DialogContent>
        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          {type !== "view" ? (
            <Button
              variant="contained"
              className="btn ms-4"
              onClick={handleSubmit}
            >
              {type === "edit" ? "Submit" : "Create"}
            </Button>
          ) : (
            <></>
          )}
        </div>
      </Dialog>
      {/* ------------------------Delete Blogs---------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>
            {type === "block" ? (status ? "Unpublish" : "Publish") : "Delete"}
          </h3>

          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14">
            {type === "block"
              ? status
                ? "Are you sure you want to unpublish the blogs ?"
                : "Are you sure you want to publish the blogs ?"
              : "Are you sure you want to delete the blogs ?"}
          </p>
        </DialogContent>
        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="btn ms-4"
            onClick={handleDelete}
          >
            {type === "block"
              ? status
                ? "Unpublish "
                : "Publish "
              : "Delete "}
          </Button>
        </div>
      </Dialog>
    </div>
  );
};
export default BlogManagement;
